import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Home, Wallet, HandCoins, ArrowLeftRight, User, Bell } from "lucide-react";
import { useEffect, useState } from "react";
import { Brand } from "@/components/Brand";
import { ThemeToggle } from "@/components/ThemeToggle";
import { api } from "@/lib/api";

const NAV = [
  { to: "/app", label: "Beranda", icon: Home, end: true, id: "home" },
  { to: "/app/tabungan", label: "Tabungan", icon: Wallet, id: "savings" },
  { to: "/app/pinjaman", label: "Pinjaman", icon: HandCoins, id: "loans" },
  { to: "/app/transaksi", label: "Transaksi", icon: ArrowLeftRight, id: "transactions" },
  { to: "/app/profil", label: "Profil", icon: User, id: "profile" },
];

export default function MobileShell() {
  const navigate = useNavigate();
  const location = useLocation();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    api.get("/me/summary").then((r) => setUnread(r.data.unread)).catch(() => {});
  }, [location.pathname]);

  return (
    <div className="max-w-md mx-auto min-h-screen bg-slate-50 relative pb-24 sm:border-x border-slate-200 sm:shadow-2xl">
      <header className="sticky top-0 z-30 bg-white/90 backdrop-blur-xl border-b border-slate-100 px-5 py-2 flex items-center justify-between">
        <button onClick={() => navigate("/app")} data-testid="header-home-link"><Brand /></button>
        <div className="flex items-center gap-1">
          <ThemeToggle />
          <button onClick={() => navigate("/app/notifikasi")} data-testid="notification-bell" className="relative p-2 rounded-full hover:bg-slate-100 transition-colors">
            <Bell className="h-6 w-6 text-slate-700" />
            {unread > 0 && (
              <span data-testid="notification-unread-count" className="absolute top-1 right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-white text-[10px] font-bold flex items-center justify-center">
                {unread > 9 ? "9+" : unread}
              </span>
            )}
          </button>
        </div>
      </header>
      <main className="pt-3"><Outlet /></main>
      <nav className="fixed bottom-0 inset-x-0 z-30 max-w-md mx-auto bg-white border-t border-slate-200 grid grid-cols-5 pb-[env(safe-area-inset-bottom)]">
        {NAV.map(({ to, label, icon: Icon, end, id }) => (
          <NavLink key={to} to={to} end={end} data-testid={`bottom-nav-${id}`}
            className={({ isActive }) => `flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition-colors ${isActive ? "text-red-600" : "text-slate-500 hover:text-slate-800"}`}>
            <Icon className="h-5 w-5" />
            {label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
